import { DouyinInfluencerProfile, DouyinInfluencers } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSocialAccountSelectButtonProps } from './hooks';

export const DouyinInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<DouyinInfluencerProfile>({
      socialMedia: InfluencersTabType.DOUYIN
    });

  return (
    <DouyinInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
